import { render } from "./subOrganization.vue?vue&type=template&id=370229ae&scoped=true"
import script from "./subOrganization.vue?vue&type=script&lang=js"
export * from "./subOrganization.vue?vue&type=script&lang=js"

import "./subOrganization.vue?vue&type=style&index=0&id=370229ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370229ae"]])

export default __exports__